export default __webpack_public_path__ + "static/media/questions-mobile.166484b1.png";